module.exports = __webpack_public_path__ + "static/img/bcg_unit9.fd81582b.png";